export const FETCH_COIN_VALUE_REQUEST = "FETCH_COIN_VALUE_REQUEST";
export const FETCH_COIN_VALUE_SUCCESS = "FETCH_COIN_VALUE_SUCCESS";
export const FETCH_COIN_VALUE_FAILURE = "FETCH_COIN_VALUE_FAILURE";